<div class="layout-content p-0 pt-3 mx-2 lg:mx-7">
	<div class="flex flex-column justify-content-center align-items-center">
		<div class="grid col-12 p-0 mt-2 sm:mt-0 md:p-1 px-2 text-center justify-content-center">
			<h3 class="page-title">{{ 'CLOSE_ACCOUNT_TITLE' | translate }}</h3>
		</div>
		<div class="grid col-12 p-0 px-2 mt-3 mb-5 lg:mb-3 sm:mt-0 md:p-1">
			<div class="card">
				<div class="grid">
					<div class="col-12 px-6 pt-5">
						<div [ngClass]="justifyTextStyleDesktop()">
							<span [innerHTML]="'CLOSE_ACCOUNT_MESSAGE' | translate"></span>
						</div>
					</div>
				</div>
					
				<form [formGroup]="closeAccountForm" class="form-signin">
					<div class="grid">
						<div class="col-12 px-3 sm:px-6 flex" [ngClass]="justifyContentStyleDesktop()">
								<p-checkbox formControlName="closeFlag"
									[binary]="true"
									value="True"
									label="{{'CLOSE_ACCOUNT_CONFIRM_CHECKBOX' | translate }}"
									(click)="setConfirmCheckbox()">
								</p-checkbox>
						</div>
						<div class="col-12 flex justify-content-around mt-2 sm:mt-5">
							<div class="flex flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
									<div class="flex align-items-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ 'PASSWORD' | translate }}</div>
									<div class="flex align-items-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
										<p-password formControlName="password" [toggleMask]="true" [feedback]="false"
											id="deleteprofile-input-password"
											maxLength="64"
											[ngClass]="dynamicInputTextWidth()" 
											styleClass="{{ dynamicInputTextWidth() }}" 
											inputStyleClass="{{ dynamicInputTextWidth() }} pl-2_5rem">
										>
										</p-password>
									</div>
							</div>
						</div>
					</div>
				</form>
				
				<div class="grid mt-3">
					<div class="col-12" [class]="onExtendedMobile() ? '' : 'flex justify-content-center'">
						<button [disabled]="!closeAccountForm.valid" type="button" pButton pRipple (click)="closeAccount($event)"
							label="{{ 'CLOSE_ACCOUNT_BUTTON' | translate }}"
							class="p-button-danger text-xl font-normal mb-2 mx-1"
							[ngClass]="dynamicButtonWidth()">
						</button>
						<button type="button" pButton pRipple (click)="backToHome()"
							label="{{ 'CANCEL' | translate }}"
							class="p-button-secondary text-xl font-normal mb-2 mx-1"
							[ngClass]="dynamicButtonWidth()">
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="col-12 flex justify-content-center">
				<button type="button" pButton
					[label]="confDialog.acceptButtonLabel"
					[ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
				</button>
				<button type="button" pButton 
					[label]="confDialog.rejectButtonLabel"
					[ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
				</button>
			</div>
		</ng-template>
	</p-confirmDialog>
	<p-progressSpinner *ngIf="showProgressSpinner" class="custom-progress-spinner" styleClass="custom-spinner" strokeWidth="3"></p-progressSpinner>
</div>